module.exports = __webpack_public_path__ + "img/user-5.43b455b1.svg";